module.exports = __webpack_public_path__ + "img/3.11529f90.png";